import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "@reduxjs/toolkit";
import { useGetProfileQuery } from "../Slices/roomNateApis";
import { setUserProfile, clearUserProfile } from "../Slices/roomNateSlice";

export const useUserProfile = () => {
  const dispatch = useDispatch();
  const { userProfile, isUserProfileLoaded, currentToken } = useSelector(
    (state) => state.roomNateSlice
  );

  // Only fetch profile if user is logged in, profile hasn't been loaded yet, and we don't already have user data
  const shouldFetch = currentToken && !isUserProfileLoaded && !userProfile;

  const { data: profileData, isSuccess, isError } = useGetProfileQuery("", {
    skip: !shouldFetch,
  });

  useEffect(() => {
    if (isSuccess && profileData) {
      dispatch(setUserProfile(profileData));
    }
  }, [isSuccess, profileData, dispatch]);

  useEffect(() => {
    if (isError || !currentToken) {
      dispatch(clearUserProfile());
    }
  }, [isError, currentToken, dispatch]);

  return {
    userProfile,
    isUserProfileLoaded,
    isLoading: shouldFetch && !isSuccess && !isError,
  };
};

const selectUserProfileData = createSelector(
  (state) => state.roomNateSlice.userProfile,
  (state) => state.roomNateSlice.isUserProfileLoaded,
  (userProfile, isUserProfileLoaded) => ({
    userProfile,
    isUserProfileLoaded,
  })
);

export const useUserProfileSelector = () => {
  return useSelector(selectUserProfileData);
};